<div class="ownership-popup">
  <div class="popup-header">
    <div class="header-left">
      <div class="header-icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="header-title">{{ 'quotations_and_orders.ownership.change_owner' | translate }}</h2>
    </div>
    <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common.cancel' | translate">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div mat-dialog-content class="popup-body">
    <div class="current-row" *ngIf="data.currentOwner?.name">
      <span class="current-label">{{ 'quotations_and_orders.ownership.owner' | translate }}</span>
      <span class="current-user">
        <span class="current-avatar">
          <img src="assets/icones/person.svg" alt="" width="18" height="18" />
        </span>
        <span class="current-name">{{ data.currentOwner?.name }}</span>
      </span>
    </div>

    <div class="input-group">
      <label class="input-label">{{ 'quotations_and_orders.ownership.select_user' | translate }}</label>
      <div class="search-box flat-field-shell">
        <div class="search-icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="#454545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <input
          type="text"
          class="search-input flat-field-input"
          [formControl]="userSearchControl"
          [matAutocomplete]="auto"
          (input)="onSearchInput(userSearchControl.value)"
          [placeholder]="'quotations_and_orders.ownership.select_user' | translate"
          autocomplete="off"
        />
        <mat-spinner *ngIf="loadingOptions" diameter="20" class="search-spinner"></mat-spinner>
      </div>
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayUser.bind(this)"
        (optionSelected)="onUserSelected($event)"
        class="owner-autocomplete-panel"
      >
        <mat-option *ngFor="let u of options" [value]="u" class="owner-option">
          <span class="opt-row">
            <span class="opt-avatar">
              <img
                *ngIf="u.image; else defaultAvatar"
                [src]="'data:image/jpeg;base64,' + u.image"
                [alt]="u.name"
                width="28"
                height="28"
                style="border-radius:50%;object-fit:cover;"
              />
              <ng-template #defaultAvatar>
                <img src="assets/icones/person.svg" alt="" width="28" height="28" />
              </ng-template>
            </span>
            <span class="opt-text">
              <span class="opt-name">{{ u.name }}</span>
              <span class="opt-email" *ngIf="u.email">{{ u.email }}</span>
            </span>
          </span>
        </mat-option>
      </mat-autocomplete>
    </div>

    <div class="input-group input-group-note">
      <label class="input-label" for="owner-note-input">{{ 'quotations_and_orders.ownership.note_placeholder' | translate }}</label>
      <div class="note-field flat-field-shell">
        <input
          id="owner-note-input"
          type="text"
          class="note-input flat-field-input"
          maxlength="200"
          [formControl]="noteControl"
          [placeholder]="'quotations_and_orders.ownership.note_short_hint' | translate"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="info-box">
      <div class="info-icon" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <p class="info-text">{{ 'quotations_and_orders.ownership.dialog_hint' | translate }}</p>
    </div>
  </div>

  <div mat-dialog-actions class="button-group">
    <button type="button" class="btn btn-cancel" (click)="cancel()" [disabled]="saving">
      {{ 'quotations_and_orders.shipping_dialog.actions.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-update" (click)="confirm()" [disabled]="saving || !selectedUser?.id">
      <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
      <ng-container *ngIf="!saving">
        {{ 'quotations_and_orders.ownership.confirm' | translate }}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </ng-container>
    </button>
  </div>
</div>
